import { Component, OnInit, Input, AfterViewInit, AfterViewChecked, ViewChild, ViewChildren, QueryList, ElementRef, HostListener } from '@angular/core';
import { Observable, of, merge } from 'rxjs';
import { TableDataService, IParamEntryItemDef, ITableDataDefResponse, ITableDataServiceOptions, ITableDataResponse } from './table-data.service';
import { map, catchError, switchMap, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { IOption, TooltipDirective } from 'ng-uikit-pro-standard';

import * as fs from 'file-saver';
import * as moment from 'moment';
import { FormOkCancelComponent, IFormOkCancelViewModel } from 'src/app/share/forms/form-ok-cancel/form-ok-cancel.component';
import { FormInputComponent, IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { AuthService } from 'src/app/share/services/auth.service';

@Component({
  selector: 'app-table-data',
  templateUrl: './table-data.component.html',
  styleUrls: ['./table-data.component.scss']
})
export class TableDataComponent implements OnInit, AfterViewInit, AfterViewChecked {

  /**
   * 
   */
  vmTable$: Observable<ITableDataViewModel>;

  vm$: Observable<ITableDataPageViewModel>;

  searchData: string = '';
  selectedValue: string = '';

  @Input() hostOptions: ITableDataHostOptions = undefined;
  @Input() layoutOptions: ITableDataLayoutOptions = undefined;
  @Input() allowEmail: boolean = true;
  @Input() allowExport: boolean = true;
  @Input() allowReload: boolean = false;

  isEventsRole: boolean = false;

  @ViewChildren('mobileScrollWrap') mobileScrollWrapEls: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('tooltipPopover') tooltipPopovers: QueryList<TooltipDirective>;
  @ViewChild('floatingScrollbar') floatingScrollbarEl: ElementRef<HTMLDivElement>;
  @ViewChild('floatingScrollbarContent') floatingScrollbarContentEl: ElementRef<HTMLDivElement>;

  showFloatingScrollbar: boolean = false;

  private activeScrollWrap: HTMLDivElement;
  private scrollSyncLock: boolean = false;
  private lastScrollMetricsKey: string = '';
  private tooltipSectionsCache: { [payload: string]: ITooltipSectionVm[] } = {};

  private readonly tooltipColumnName: string = 'tooltip';
  private readonly tooltipResColumnAliases: string[] = ['res #', 'res#', 'conf #', 'confirmnumber', 'reservation #'];

  /**
   * 
   * @param svc 
   * @param route 
   */
  constructor(private svc: TableDataService, private route: ActivatedRoute, private authService: AuthService) { }

  /**
   * 
   * @param vm 
   * @param vmTable 
   * @param confirmed 
   * @returns 
   */
  view(vm: ITableDataPageViewModel, vmTable: ITableDataViewModel, confirmed: number) {

    vmTable.rows = [];
    if ((vm.def.collectReasons ?? false) && (vm.def.reasonQuestions ?? []).length > 0 && confirmed == 0) {
      vm.reasonFormVm = this.setReasonFormVm(vm, 'view');
      return;
    }
    this.viewImpl(vm, vmTable);
  }

  setReasonFormVm(vm: ITableDataPageViewModel, action): IReasonEntryFormViewModel {

    const data = this.setReasonFormData(vm);

    const ret: IReasonEntryFormViewModel = {
      data: data,

      okCancelVm: FormOkCancelComponent.okCancelVm({}),

      reasonAnswerVm1: (vm.def.reasonQuestions[0] ?? '').length > 0 
        ? FormInputComponent.viewModel(data, 'reasonAnswer1', { title: vm.def.reasonQuestions[0], isRequired: false, isLocked: false })
        : undefined,

      reasonAnswerVm2: (vm.def.reasonQuestions[1] ?? '').length > 0 
        ? FormInputComponent.viewModel(data, 'reasonAnswer2', { title: vm.def.reasonQuestions[1], isRequired: false, isLocked: false })
        : undefined,

      reasonAnswerVm3: (vm.def.reasonQuestions[2] ?? '').length > 0 
        ? FormInputComponent.viewModel(data, 'reasonAnswer3', { title: vm.def.reasonQuestions[2], isRequired: false, isLocked: false })
        : undefined,

      reasonAnswerVm4: (vm.def.reasonQuestions[3] ?? '').length > 0 
        ? FormInputComponent.viewModel(data, 'reasonAnswer4', { title: vm.def.reasonQuestions[3], isRequired: false, isLocked: false })
        : undefined,

      reasonAnswerVm5: (vm.def.reasonQuestions[4] ?? '').length > 0 
        ? FormInputComponent.viewModel(data, 'reasonAnswer5', { title: vm.def.reasonQuestions[4], isRequired: false, isLocked: false })
        : undefined,

      isValid: false,
      action: action
    }
    return ret;
  }

  /**
   * 
   * @returns 
   */
  setReasonFormData(vm: ITableDataPageViewModel): IReasonEntryFormData {
    return {
      reasonQuestion1: vm.def.reasonQuestions[0],
      reasonQuestion2: vm.def.reasonQuestions[1],
      reasonQuestion3: vm.def.reasonQuestions[2],
      reasonQuestion4: vm.def.reasonQuestions[3],
      reasonQuestion5: vm.def.reasonQuestions[4],
      reasonAnswer1: '',
      reasonAnswer2: '',
      reasonAnswer3: '',
      reasonAnswer4: '',
      reasonAnswer5: ''
    };
  }

  /**
   * 
   * @param vm 
   * @param fvm 
   */
  reasonFormValidate(vm: ITableDataPageViewModel, rvm: IReasonEntryFormViewModel) {
    const ret = (
      (rvm.data.reasonAnswer1.trim() ?? '').length > 5
      || (rvm.data.reasonAnswer2.trim() ?? '').length > 5
      || (rvm.data.reasonAnswer3.trim() ?? '').length > 5
      || (rvm.data.reasonAnswer4.trim() ?? '').length > 5
      || (rvm.data.reasonAnswer5.trim() ?? '').length > 5
    );
    rvm.isValid = ret;
  }

  /**
   * 
   */
  reasonFormCanceled(vm: ITableDataPageViewModel) {
    vm.reasonFormVm = undefined;
  }

  reasonFormOk(vm: ITableDataPageViewModel, rvm: IReasonEntryFormViewModel) {
    vm.reasonFormVm = undefined;

    var reasonsParams: IReasonsParam[] = [];
    if (rvm.data) {
      var reasonParams: IReasonsParam[] = [];
      if ((rvm?.data?.reasonQuestion1 ?? '').length > 0 && (rvm?.data?.reasonAnswer1 ?? '').length > 0) {
        reasonParams.push({ question: rvm?.data?.reasonQuestion1, answer: rvm?.data?.reasonAnswer1});
      }
      if ((rvm?.data?.reasonQuestion2 ?? '').length > 0 && (rvm?.data?.reasonAnswer2 ?? '').length > 0) {
        reasonParams.push({ question: rvm?.data?.reasonQuestion2, answer: rvm?.data?.reasonAnswer2});
      }
      if ((rvm?.data?.reasonQuestion3 ?? '').length > 0 && (rvm?.data?.reasonAnswer3 ?? '').length > 0) {
        reasonParams.push({ question: rvm?.data?.reasonQuestion3, answer: rvm?.data?.reasonAnswer3});
      }
      if ((rvm?.data?.reasonQuestion4 ?? '').length > 0 && (rvm?.data?.reasonAnswer4 ?? '').length > 0) {
        reasonParams.push({ question: rvm?.data?.reasonQuestion4, answer: rvm?.data?.reasonAnswer4});
      }
      if ((rvm?.data?.reasonQuestion5 ?? '').length > 0 && (rvm?.data?.reasonAnswer5 ?? '').length > 0) {
        reasonParams.push({ question: rvm?.data?.reasonQuestion5, answer: rvm?.data?.reasonAnswer5});
      }
      if (reasonParams.length > 0) {
        vm.paramData.reasonParams = reasonParams;
        vm.paramData.userName = this.authService.userName();
      }
    }
    
    switch(rvm.action) {
      case 'view': this.viewImpl(vm, undefined); break;
      case 'export': this.exportImpl(vm, undefined); break;
      case 'email': this.emailImpl(vm, undefined); break;
    }
  }

  /**
   * 
   * @param vm
   */
  viewImpl(vm: ITableDataPageViewModel, vmTable: ITableDataViewModel) {
    
    const intitial$: Observable<ITableDataViewModel> = of({
      workingText: 'Loading Data...',
      errorText: undefined
    });

    const loader$ = this.svc.viewData(vm.def.code, vm.paramData, this.hostOptions?.serviceOptions).pipe(
      map(v => {
        const rowsAndColumns = this.buildRowsAndColumns(v);

        const ret: ITableDataViewModel = {
          workingText: undefined,
          errorText: v.success ? undefined : v.message,
          dataLimitMessage: v.dataLimitMessage,

          ...rowsAndColumns,

          iconNames: this.setIconNames(rowsAndColumns.columns),

          groupedVm: this.groupedVm({ rows: v.rows, columns: v.columns })
        };

        // notify host if he cares
        this.notifyTableDataChanged(ret);

        return ret;

      }),
      catchError((e, v) => of({ workingText: undefined, errorText: e.message ? e.message : e }))
    );

    this.vmTable$ = merge(intitial$, loader$);
  }

  /**
   * 
   * @param arg 
   * @returns 
   */
  isSpecial(arg: string): boolean {
    return this.isPhone(arg) || this.isCsv(arg) || this.isList(arg);
  }

  getCellDisplayValue(f: string, idx: number, vmTable: ITableDataViewModel): string {
    if (!this.isSpecialCell(f, idx, vmTable) && this.isCsv(f)) {
      const parts = this.csv(f);
      return parts.some(p => p.trim().length > 0) ? f : '';
    }
    return f;
  }

  isSpecialCell(arg: string, idx: number, vmTable: ITableDataViewModel): boolean {
    if (this.isPhone(arg) || this.isList(arg))
      return true;

    if (!this.isCsv(arg))
      return false;

    return this.shouldSplitCsvForColumn(idx, vmTable);
  }

  private shouldSplitCsvForColumn(idx: number, vmTable: ITableDataViewModel): boolean {
    return true;
  }

  /**
   * 
   * @param arg 
   * @returns 
   */
  isList(arg: string): boolean {
    return arg.includes('|');
  }

  /**
   * 
   * @param arg 
   * @returns 
   */
  isCsv(arg: string): boolean {
    return arg.includes(',');
  }

  /**
   * 
   * @param arg 
   * @returns 
   */
  list(arg: string): string[] {
    return (arg || '').split('|').map(v => v.trim());
  }

  /**
   * 
   * @param arg 
   * @returns 
   */
  csv(arg: string): string[] {
    return (arg || '').split(',').map(v => v.trim());
  }

  /**
   * 
   * @param arg 
   */
  isPhone(arg: string): boolean {
    const parts = (arg || '').split('-');
    return parts.length == 4 && parts[0].length == 1;
  }

  /**
   * 
   * @param arg 
   * @returns 
   */
  private buildRowsAndColumns(arg: ITableDataResponse): { columns: string[], rows: string[][], rowsFiltered: string[][] } {
    const tooltipNdxByName = this.findTooltipColumnIndex(arg.columns);
    const tooltipNdx = tooltipNdxByName > -1 ? tooltipNdxByName : this.findTooltipColumnIndexByContent(arg.rows, arg.columns?.length ?? 0);
    const tooltipData = tooltipNdx < 0 ? undefined : arg.rows.map(r => r[tooltipNdx] ?? '');

    if (!this.layoutOptions?.tableColumns) {
      const columns = tooltipNdx < 0 ? [...arg.columns] : arg.columns.filter((v, ndx) => ndx != tooltipNdx);
      const rows = tooltipNdx < 0
        ? arg.rows.map(r => [...r])
        : arg.rows.map(r => r.filter((v, ndx) => ndx != tooltipNdx));

      const ret = {
        columns: columns,
        rows: rows,
        rowsFiltered: [...rows],
        tooltipData: tooltipData,
        tooltipDataFiltered: tooltipData ? [...tooltipData] : undefined,
        tooltipColIdx: tooltipNdx,
        tooltipResColIdx: this.findResColumnIndex(columns)
      };
      return ret;
    }

    // will ignore any misses on column lookups
    const columnDefs = this.layoutOptions.tableColumns
      .map(tc => ({ ...tc, colNdx: arg.columns.findIndex(c => c.toLowerCase() == tc.title.toLowerCase()) }))
      .filter(v => v.colNdx >= 0 && v.colNdx != tooltipNdx);
    
    const rows = arg.rows.map(r => {
      const ret: any[] = columnDefs.map(cd => {
        const cellValue = r[cd.colNdx];

        const ret = cd.formatFunc ? cd.formatFunc(cellValue) : cellValue;
        return ret;
      });
      
      return ret;
    });
    const columns = columnDefs.map(cd => cd.titleOverride ?? cd.title);

    return {
      columns: columns,
      rows: rows,
      rowsFiltered: [...rows],
      tooltipData: tooltipData,
      tooltipDataFiltered: tooltipData ? [...tooltipData] : undefined,
      tooltipColIdx: tooltipNdx,
      tooltipResColIdx: this.findResColumnIndex(columns)
    };
  }

  /**
   * vm
   */
  private notifyTableDataChanged(vm: ITableDataViewModel) {
    if (this.hostOptions?.tableDataChanged)
    this.hostOptions.tableDataChanged({ columns: vm.columns, rows: vm.rows ?? [], filteredRows: vm.rowsFiltered ?? [], groupedRows: vm.groupedVm?.filteredRows ?? [] });
  }

  /**
   * 
   * @param columns 
   * @returns 
   */
  private setIconNames(columns: string[]): string[] {
    var ret: string[] = [];

    for(var i = 0; i < columns.length; i++) {
      ret.push('arrows-alt-v');
    }

    return ret;
  }

  /**
   * 
   * @param v 
   * @returns 
   */
  private groupedVm(v: { rows: string[][], columns: string[] }): IGroupedVm {
    if (!this.layoutOptions?.groupedColumns)
      return undefined;

    const rows: ITableDataGroupRow[] = [];

    (v.rows || []).forEach(r => {

      const cells = this.layoutOptions.groupedColumns.map(gc => {

        const cellRows = gc.titleDefs.map(td => {
          const ndx = v.columns.findIndex(c => c.toUpperCase() == td.columnName.toUpperCase());

          const ret = { title: td.title, value: td.formatter ? td.formatter(r[ndx]) : r[ndx] };
          return ret;
        });

        const ret: ITableDataGroupRowCell = { columnName: gc.columnName, cellRows: cellRows };
        return ret;
      });

      rows.push({ cells: cells });
    });

    const columnNames = this.layoutOptions.groupedColumns.map(gc => gc.columnName);

    const ret: IGroupedVm = {
      columns: columnNames,
      rows: rows,
      filteredRows: [...rows],
      styleWidth: `${100 / columnNames.length}%`
    };
    return ret;
  }

  /**
   * 
   * @param vm 
   * @param vmTable 
   * @param confirmed 
   * @returns 
   */
  export(vm: ITableDataPageViewModel, vmTable: ITableDataViewModel, confirmed: number) {
    if ((vm.def.collectReasons ?? false) && (vm.def.reasonQuestions ?? []).length > 0 && confirmed == 0) {
      vm.reasonFormVm = this.setReasonFormVm(vm, 'export');
      return;
    }
    this.exportImpl(vm, vmTable);
  }
  /**
   * 
   * @param vm 
   */
  exportImpl(vm: ITableDataPageViewModel, vmTable: ITableDataViewModel) {

    const intitial$: Observable<ITableDataViewModel> = of({
      workingText: 'Exporting Data...',
      errorText: undefined
    });

    const export$ = this.svc.exportData(vm.def.code, vm.paramData, this.hostOptions?.serviceOptions).pipe(
      tap((blob: Blob) => {
        const fileName = vm.def?.zipFileName?.length ? this.formatFileName(vm.def?.zipFileName, vm.paramData) : vm.def.code;
        fs.saveAs(blob, `${fileName}.zip`);
      }),
      map((v: any) => ({
        workingText: undefined,
        errorText: undefined,
        actionText: 'Success'
      })),
      catchError((e, v) => of({ workingText: undefined, errorText: e.message ? e.message : e }))
    );

    this.vmTable$ = merge(intitial$, export$);
  }

  /**
   * 
   * @param vm 
   * @param vmTable 
   * @param confirmed 
   * @returns 
   */
  email(vm: ITableDataPageViewModel, vmTable: ITableDataViewModel, confirmed: number) {
    if ((vm.def.collectReasons ?? false) && (vm.def.reasonQuestions ?? []).length > 0 && confirmed == 0) {
      vm.reasonFormVm = this.setReasonFormVm(vm, 'email');
      return;
    }
    this.emailImpl(vm, vmTable);
  }
  /**
   * 
   * @param vm 
   */
  emailImpl(vm: ITableDataPageViewModel, vmTable: ITableDataViewModel) {
    const intitial$: Observable<ITableDataViewModel> = of({
      workingText: 'Emailing Data...',
      errorText: undefined
    });

    const loader$ = this.svc.emailData(vm.def.code, vm.emailAddress, vm.paramData, this.hostOptions?.serviceOptions).pipe(
      map(v => ({
        workingText: undefined,
        errorText: v.success ? undefined : v.message,
        actionText: 'Success'
      })),
      catchError((e, v) => of({ workingText: undefined, errorText: e.message ? e.message : e }))
    );

    this.vmTable$ = merge(intitial$, loader$);
  }

  formatFileName(template: string, paramData: string): string {
    
    let json = JSON.parse(JSON.stringify(paramData));
    
    let retFileName = template;
    if (template.includes('[INVOICE]')) {
      retFileName = template.replace('[INVOICE]', json.invoiceNumber);
    } else if (template.includes('[DATE]')) {
      retFileName = template.replace('[DATE]', moment(new Date()).format('MMDDYYYY'));
    }
    return retFileName;
  }

  /**
   * 
   */
  ngOnInit() {
    this.isEventsRole = this.authService.isCustomerRoleEvents();

    const intial$ = of({
      workingText: 'Loading Definition...'
    });

    const loader$ = this.route.paramMap.pipe(
      map(v => this.hostOptions ? this.hostOptions.reportCode : v.get('code')),
      switchMap(code => this.svc.getDefinition(code, this.hostOptions?.serviceOptions)),
      map((v: ITableDataDefResponse) => {
        const paramData: any = !this.hostOptions ? {} : {
          ...this.hostOptions.paramOverrides
        };

        const items: IParamEntryItemViewModel[] = v.defs.filter(d => !this.hostOptions ? true : (this.hostOptions.paramHidden[d.code] ?? false) == false).map(d => ({
          def: d,
          options: d.selectItems ? d.selectItems.map(i => ({ value: i.value, label: i.label, icon: undefined })) : [],
          modelGet: () => paramData[d.code],
          modelSet: (v) => paramData[d.code] = v,
          hidden: this.hostOptions ? this.hostOptions.paramHidden[d.code] ?? false : false
        }));

        return {
          def: {
            ...v,
            title: this.layoutOptions?.titleOverride ?? v.title
          },
          items: items,
          paramData: paramData,
          workingText: undefined
        };
      }),
      catchError((e, v) => of({ workingText: undefined, errorText: e.message ? e.message : e }))
    );

    this.vm$ = merge(intial$, loader$);
    this.vmTable$ = of({});
  }

  ngAfterViewInit() {
    this.refreshFloatingScrollbar();
  }

  ngAfterViewChecked() {
    this.refreshFloatingScrollbar();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.refreshFloatingScrollbar();
  }

  onTableWrapScroll(event: Event) {
    if (this.scrollSyncLock || !this.floatingScrollbarEl?.nativeElement)
      return;

    const source = event.target as HTMLDivElement;
    if (!source)
      return;

    this.activeScrollWrap = source;
    this.scrollSyncLock = true;
    this.floatingScrollbarEl.nativeElement.scrollLeft = source.scrollLeft;
    this.scrollSyncLock = false;
  }

  onFloatingScrollbarScroll() {
    if (this.scrollSyncLock || !this.activeScrollWrap || !this.floatingScrollbarEl?.nativeElement)
      return;

    this.scrollSyncLock = true;
    this.activeScrollWrap.scrollLeft = this.floatingScrollbarEl.nativeElement.scrollLeft;
    this.scrollSyncLock = false;
  }

  private refreshFloatingScrollbar() {
    const wrap = this.getVisibleScrollWrap();
    const floating = this.floatingScrollbarEl?.nativeElement;
    const floatingContent = this.floatingScrollbarContentEl?.nativeElement;

    if (!wrap || !floating || !floatingContent) {
      this.showFloatingScrollbar = false;
      return;
    }

    this.activeScrollWrap = wrap;

    const needsHorizontalScroll = wrap.scrollWidth > wrap.clientWidth + 1;
    const shouldShow = needsHorizontalScroll && window.innerWidth <= 991;

    if (!shouldShow) {
      this.showFloatingScrollbar = false;
      return;
    }

    const metricsKey = `${wrap.scrollWidth}|${wrap.clientWidth}|${wrap.scrollLeft}|${window.innerWidth}`;
    if (metricsKey === this.lastScrollMetricsKey && this.showFloatingScrollbar)
      return;

    this.lastScrollMetricsKey = metricsKey;
    this.showFloatingScrollbar = true;
    floatingContent.style.width = `${wrap.scrollWidth}px`;

    this.scrollSyncLock = true;
    floating.scrollLeft = wrap.scrollLeft;
    this.scrollSyncLock = false;
  }

  private getVisibleScrollWrap(): HTMLDivElement {
    const wraps = this.mobileScrollWrapEls?.toArray().map(v => v.nativeElement) ?? [];
    const visibleWrap = wraps.find(w => w.offsetParent !== null);
    return visibleWrap;
  }

  /**
   * 
   * @param vm 
   * @param searchVal 
   * @returns 
   */
  doDataSearch(vm: ITableDataViewModel, searchVal: string) {
    
    // filter groups if grouped
    if (vm.groupedVm) {
      vm.groupedVm.filteredRows = searchVal.length == 0 ? [...vm.groupedVm.rows] : vm.groupedVm.rows.filter(r => {
        return r.cells.findIndex(c =>
          c.cellRows.findIndex(cr =>
            (cr.value || '').toLowerCase().indexOf(searchVal.toLowerCase()) > -1
          ) > -1
        ) > -1
      });
    }

    // always filter rows
    if (searchVal.length == 0) {
      vm.rowsFiltered = [...vm.rows];
      vm.tooltipDataFiltered = vm.tooltipData ? [...vm.tooltipData] : undefined;
    }
    else {
      const matchingRows = vm.rows.reduce((pv, cv: string[], rowNdx: number) => {
        const rowFound = cv.find(v => v.toLowerCase().indexOf(searchVal.toLowerCase()) > -1);
        return rowFound ? [...pv, { row: cv, rowNdx: rowNdx }] : [...pv];
      }, [] as { row: string[], rowNdx: number }[]);

      vm.rowsFiltered = matchingRows.map(v => v.row);
      vm.tooltipDataFiltered = vm.tooltipData
        ? matchingRows.map(v => vm.tooltipData[v.rowNdx] ?? '')
        : undefined;
    }

    // notify host if he cares
    this.notifyTableDataChanged(vm);

  }

  getSelectedValue(value: string, v: any) {
    
  }

  onSort(idx: number, tbl: ITableDataViewModel) {
    
    tbl.iconNames[idx] = tbl.iconNames[idx] == 'arrows-alt-v'
      ? 'arrow-down'
      : tbl.iconNames[idx] == 'arrow-down'
        ? 'arrow-up'
        : tbl.iconNames[idx] == 'arrow-up'
          ? 'arrow-down'
          : 'arrows-alt-v';

    switch(tbl.iconNames[idx]) {
      case 'arrow-up':
        tbl.rowsFiltered.sort((a,b) => (a[idx] > b[idx] ? -1 : 1));
        break;
      case 'arrow-down':
        tbl.rowsFiltered.sort((a,b) => (a[idx] > b[idx] ? 1 : -1));
        break;
    }

    for(var i = 0; i < tbl.columns.length; i++) {
      if (i != idx)
        tbl.iconNames[i] = 'arrows-alt-v';
    }
  }

  setColumnStyle(idx: number, tbl: ITableDataViewModel): string {
    for(var i = 0; i < tbl.columns.length; i++) {
      if ((tbl.iconNames[i] === 'arrow-up' || tbl.iconNames[i] === 'arrow-down') && i === idx) {
        return 'font-weight: bold;';
      }
    }
    return '';
  }

  setHeaderStyle(idx: number, tbl: ITableDataViewModel): string {
    for(var i = 0; i < tbl.columns.length; i++) {
      if ((tbl.iconNames[i] === 'arrow-up' || tbl.iconNames[i] === 'arrow-down') && i === idx) {
        return 'background-color: #686868';
      }
    }
    return '';
  }

  getTooltipSections(payload: string): ITooltipSectionVm[] {
    const cacheKey = payload ?? '';
    if (this.tooltipSectionsCache[cacheKey])
      return this.tooltipSectionsCache[cacheKey];

    if (!payload || payload.trim().length == 0) {
      this.tooltipSectionsCache[cacheKey] = [];
      return [];
    }

    try {
      const parsed = this.tryParseJsonLike(payload);
      const ret = this.normalizeTooltipPayload(parsed);
      this.tooltipSectionsCache[cacheKey] = ret;
      return ret;
    }
    catch {
      const ret = [{ title: 'Details', fields: [{ value: payload }] }];
      this.tooltipSectionsCache[cacheKey] = ret;
      return ret;
    }
  }

  getRouteSections(sections: ITooltipSectionVm[]): ITooltipSectionVm[] {
    return (sections || []).filter(s => this.isRouteSectionTitle(s?.title));
  }

  getNonRouteSections(sections: ITooltipSectionVm[]): ITooltipSectionVm[] {
    return (sections || []).filter(s => !this.isRouteSectionTitle(s?.title));
  }

  getSectionsBeforeRouteCard(sections: ITooltipSectionVm[]): ITooltipSectionVm[] {
    const nonRouteSections = this.getNonRouteSections(sections);
    const routeSections = this.getRouteSections(sections);
    if (routeSections.length == 0)
      return nonRouteSections;

    const passengerNdx = nonRouteSections.findIndex(s => this.isPassengerSectionTitle(s?.title));
    if (passengerNdx < 0)
      return nonRouteSections;

    return nonRouteSections.slice(0, passengerNdx + 1);
  }

  getSectionsAfterRouteCard(sections: ITooltipSectionVm[]): ITooltipSectionVm[] {
    const nonRouteSections = this.getNonRouteSections(sections);
    const routeSections = this.getRouteSections(sections);
    if (routeSections.length == 0)
      return [];

    const passengerNdx = nonRouteSections.findIndex(s => this.isPassengerSectionTitle(s?.title));
    if (passengerNdx < 0)
      return [];

    return nonRouteSections.slice(passengerNdx + 1);
  }

  private isRouteSectionTitle(title: string): boolean {
    const normalized = (title || '').toLowerCase().replace(/[^a-z]/g, '');
    return normalized.indexOf('pickup') > -1
      || normalized.indexOf('dropoff') > -1
      || normalized == 'drop'
      || normalized.indexOf('stop') > -1;
  }

  private isPassengerSectionTitle(title: string): boolean {
    const normalized = (title || '').toLowerCase().replace(/[^a-z]/g, '');
    return normalized.indexOf('passenger') > -1 || normalized == 'pax';
  }

  getRowTooltipPayload(vmTable: ITableDataViewModel, row: string[], rowNdx: number): string {
    if (!vmTable)
      return '';

    const filteredPayload = vmTable.tooltipDataFiltered && vmTable.tooltipDataFiltered.length > rowNdx
      ? (vmTable.tooltipDataFiltered[rowNdx] ?? '')
      : '';
    if (this.looksLikeTooltipJson(filteredPayload))
      return filteredPayload;

    const sourceRowNdx = (vmTable.rows || []).findIndex(r => r === row);
    if (sourceRowNdx > -1 && vmTable.tooltipData && vmTable.tooltipData.length > sourceRowNdx) {
      const sourcePayload = vmTable.tooltipData[sourceRowNdx] ?? '';
      if (this.looksLikeTooltipJson(sourcePayload))
        return sourcePayload;
    }

    const rowPayload = this.findTooltipPayloadInRow(row);
    if (rowPayload.length > 0)
      return rowPayload;

    return '';
  }

  getRowConfirmationNumber(vmTable: ITableDataViewModel, row: string[]): string {
    if (!vmTable?.columns || !row)
      return '';

    const resNdx = this.findResColumnIndex(vmTable.columns);
    if (resNdx < 0 || resNdx >= row.length)
      return '';

    return (row[resNdx] || '').trim();
  }

  private normalizeTooltipPayload(payload: any): ITooltipSectionVm[] {
    if (this.isArray(payload))
      return payload.map((v, ndx) => this.normalizeTooltipSection(v, `Section ${ndx + 1}`)).filter(v => v.fields.length > 0);

    if (this.isPlainObject(payload)) {
      const obj = payload as any;
      if (this.isArray(obj.sections))
        return obj.sections.map((v, ndx) => this.normalizeTooltipSection(v, `Section ${ndx + 1}`)).filter(v => v.fields.length > 0);

      if (obj.title || obj.fields || obj.values)
        return [this.normalizeTooltipSection(obj, 'Details')].filter(v => v.fields.length > 0);

      const keys = Object.keys(obj);
      const allNested = keys.length > 0 && keys.every(k => this.isPlainObject(obj[k]) || this.isArray(obj[k]));
      if (allNested) {
        return keys
          .map(k => this.normalizeTooltipSection({ title: k, sectionData: obj[k] }, k))
          .filter(v => v.fields.length > 0);
      }

      return [this.normalizeTooltipSection({ title: 'Details', sectionData: obj }, 'Details')].filter(v => v.fields.length > 0);
    }

    return [{ title: 'Details', fields: [{ value: this.toText(payload) }] }].filter(v => v.fields.length > 0);
  }

  private normalizeTooltipSection(section: any, titleFallback: string): ITooltipSectionVm {
    const source = this.isPlainObject(section) ? section : { value: section };
    const title = this.toText(source.title || source.header || source.name) || titleFallback;
    const fields: ITooltipSectionFieldVm[] = [];

    if (this.isArray(source.fields)) {
      source.fields.forEach(f => {
        const field = this.normalizeTooltipField(f);
        if (field)
          fields.push(field);
      });
    }

    if (this.isArray(source.values)) {
      source.values.forEach(v => {
        const value = this.toText(v);
        if (value.length > 0)
          fields.push({ value: value });
      });
    }

    const sectionData = source.sectionData ?? source;
    if (fields.length == 0 && this.isPlainObject(sectionData)) {
      Object.keys(sectionData)
        .filter(k => k != 'title' && k != 'header' && k != 'name' && k != 'fields' && k != 'values' && k != 'sectionData')
        .forEach(k => {
          const nestedValue = sectionData[k];
          if (this.isArray(nestedValue)) {
            nestedValue.forEach(v => {
              const value = this.toText(v);
              if (value.length > 0)
                fields.push({ label: k, value: value });
            });
            return;
          }

          if (this.isPlainObject(nestedValue)) {
            Object.keys(nestedValue).forEach(nk => {
              const value = this.toText(nestedValue[nk]);
              if (value.length > 0)
                fields.push({ label: `${k} ${nk}`, value: value });
            });
            return;
          }

          const value = this.toText(nestedValue);
          if (value.length > 0)
            fields.push({ label: k, value: value });
        });
    }

    return { title: title, fields: fields };
  }

  private normalizeTooltipField(field: any): ITooltipSectionFieldVm {
    if (this.isPlainObject(field)) {
      const label = this.toText(field.label || field.key || field.name);
      const value = this.toText(field.value);
      if (value.length > 0)
        return label.length > 0 ? { label: label, value: value } : { value: value };

      const keys = Object.keys(field);
      if (keys.length == 1) {
        const onlyKey = keys[0];
        const onlyValue = this.toText(field[onlyKey]);
        if (onlyValue.length > 0)
          return { label: onlyKey, value: onlyValue };
      }
      return undefined;
    }

    const value = this.toText(field);
    return value.length > 0 ? { value: value } : undefined;
  }

  private toText(arg: any): string {
    if (arg === undefined || arg === null)
      return '';
    return `${arg}`.trim();
  }

  private isArray(arg: any): boolean {
    return Array.isArray(arg);
  }

  private isPlainObject(arg: any): boolean {
    return arg !== null && typeof arg == 'object' && !Array.isArray(arg);
  }

  private normalizeColumnName(arg: string): string {
    return (arg || '').toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9]/g, '');
  }

  private findTooltipColumnIndex(columns: string[]): number {
    return (columns || []).findIndex(c => this.normalizeColumnName(c).indexOf(this.normalizeColumnName(this.tooltipColumnName)) > -1);
  }

  private findTooltipColumnIndexByContent(rows: string[][], columnCount: number): number {
    if (!rows || rows.length == 0 || columnCount <= 0)
      return -1;

    let bestIndex = -1;
    let bestScore = 0;

    for (let cix = 0; cix < columnCount; cix++) {
      let score = 0;

      for (const row of rows) {
        const cell = row?.[cix] ?? '';
        if (this.looksLikeTooltipJson(cell))
          score++;
      }

      if (score > bestScore) {
        bestScore = score;
        bestIndex = cix;
      }
    }

    return bestScore > 0 ? bestIndex : -1;
  }

  private looksLikeTooltipJson(value: string): boolean {
    const raw = (value || '').trim();
    try {
      const parsed = this.tryParseJsonLike(raw);
      if (this.isArray(parsed))
        return parsed.length > 0;

      if (!this.isPlainObject(parsed))
        return false;

      const obj = parsed as any;
      if (this.isArray(obj.sections))
        return obj.sections.length > 0;

      return !!(obj.title || obj.fields || obj.values);
    }
    catch {
      return false;
    }
  }

  private findTooltipPayloadInRow(row: string[]): string {
    if (!row || row.length == 0)
      return '';

    for (const cell of row) {
      if (this.looksLikeTooltipJson(cell))
        return cell;
    }

    return '';
  }

  private tryParseJsonLike(value: string): any {
    const raw = (value || '').trim();
    if (raw.length == 0)
      throw new Error('Empty payload');

    let parsed: any;
    try {
      parsed = JSON.parse(raw);
    } catch {
      // API sometimes returns JSON with missing commas between pairs — attempt repair
      const fixed = this.repairMissingCommasInJson(raw);
      parsed = JSON.parse(fixed);
    }

    if (typeof parsed == 'string') {
      const nested = parsed.trim();
      if (nested.startsWith('{') || nested.startsWith('['))
        try { parsed = JSON.parse(nested); } catch { parsed = JSON.parse(this.repairMissingCommasInJson(nested)); }
    }

    return parsed;
  }

  private repairMissingCommasInJson(raw: string): string {
    // Insert missing commas between adjacent JSON tokens: " " , } { , } " , ] " , ] { etc.
    return raw
      .replace(/(")(\s+)(")/g, '$1,$2$3')
      .replace(/(")(\s+)(\{)/g, '$1,$2$3')
      .replace(/(")(\s+)(\[)/g, '$1,$2$3')
      .replace(/(\})(\s+)(")/g, '$1,$2$3')
      .replace(/(\})(\s+)(\{)/g, '$1,$2$3')
      .replace(/(\})(\s+)(\[)/g, '$1,$2$3')
      .replace(/(\])(\s+)(")/g, '$1,$2$3')
      .replace(/(\])(\s+)(\{)/g, '$1,$2$3')
      .replace(/(\])(\s+)(\[)/g, '$1,$2$3');
  }

  private findResColumnIndex(columns: string[]): number {
    const normalizedColumns = (columns || []).map(c => this.normalizeColumnName(c));
    const normalizedAliases = this.tooltipResColumnAliases.map(a => this.normalizeColumnName(a));

    const exactMatchNdx = normalizedColumns.findIndex(c => normalizedAliases.includes(c));
    if (exactMatchNdx > -1)
      return exactMatchNdx;

    return normalizedColumns.findIndex(c => c.indexOf('res') > -1 && (c.indexOf('number') > -1 || c.indexOf('no') > -1));
  }

  isResTooltipColumn(vmTable: ITableDataViewModel, idx: number): boolean {
    if (!vmTable?.columns || idx < 0)
      return false;

    const matchedNdx = this.findResColumnIndex(vmTable.columns);
    return matchedNdx == idx;
  }

  onTooltipIconClick(activeTooltip: TooltipDirective): void {
    if (!this.tooltipPopovers)
      return;

    this.tooltipPopovers.forEach(t => {
      if (t && t !== activeTooltip)
        t.hide();
    });
  }

  closeTooltip(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.tooltipPopovers)
      return;

    this.tooltipPopovers.forEach(t => t?.hide());
  }

}

/**
 * 
 */
interface ITableDataViewModel {
  workingText?: string;
  errorText?: string;
  actionText?: string;
  dataLimitMessage?: string;

  columns?: string[];
  rows?: string[][];  
  rowsFiltered?: string[][];
  tooltipData?: string[];
  tooltipDataFiltered?: string[];
  tooltipResColIdx?: number;

  iconNames?: string[];

  groupedVm?: IGroupedVm;
}

interface ITableDataPageViewModel {
  def?: ITableDataDefResponse;

  items?: IParamEntryItemViewModel[];
  paramData?: any;

  emailAddress?: string;

  workingText?: string;
  errorText?: string;

  reasonFormVm?: IReasonEntryFormViewModel;
}

/**
 * 
 */
interface IReasonEntryFormViewModel {
  data: IReasonEntryFormData;

  okCancelVm?: IFormOkCancelViewModel;

  reasonAnswerVm1?: IFormInputViewModel;
  reasonAnswerVm2?: IFormInputViewModel;
  reasonAnswerVm3?: IFormInputViewModel;
  reasonAnswerVm4?: IFormInputViewModel;
  reasonAnswerVm5?: IFormInputViewModel;

  isValid: boolean;
  action: string;
}

interface IReasonEntryFormData {
  reasonQuestion1?: string;
  reasonQuestion2?: string;
  reasonQuestion3?: string;
  reasonQuestion4?: string;
  reasonQuestion5?: string;

  reasonAnswer1?: string;
  reasonAnswer2?: string;
  reasonAnswer3?: string;
  reasonAnswer4?: string;
  reasonAnswer5?: string;
}

interface IReasonsParam {
  question?: string;
  answer?: string;
}

interface IParamEntryItemViewModel {
  def: IParamEntryItemDef;

  options?: IOption[];

  modelSet: (value: any) => void;
  modelGet: () => any;
}

/**
 * 
 */
export interface ITableDataHostOptions {
  reportCode: string;
  paramOverrides: any;
  paramHidden: any;

  serviceOptions?: ITableDataServiceOptions;

  tableDataChanged?: (arg: ITableDataHostDataChangedArg) => void;
}

/**
 * 
 */
export interface ITableDataHostDataChangedArg {
  columns: string[];
  rows: string[][];
  filteredRows: string[][];

  groupedRows: ITableDataGroupRow[];
}

/**
 * 
 */
export interface ITableDataLayoutOptions {
  titleOverride?: string;
  
  tableColumns?: { title: string, titleOverride: string, formatFunc?: (value: string) => string | string[] }[];
  
  groupedColumns?: {
    columnName: string;
    titleDefs: {
      columnName: string;
      title?: string;
      formatter?: (v) => string
    }[]
  }[];
}

/**
 * 
 */
interface IGroupedVm {
  columns: string[];
  rows: ITableDataGroupRow[];
  filteredRows: ITableDataGroupRow[];
  styleWidth: string;
}

/**
 * 
 */
export interface ITableDataGroupRow {
  cells: ITableDataGroupRowCell[]
}

/**
 * 
 */
export interface ITableDataGroupRowCell {
  columnName: string;
  cellRows: { title: string, value: string }[];
}

interface ITooltipSectionVm {
  title: string;
  fields: ITooltipSectionFieldVm[];
}

interface ITooltipSectionFieldVm {
  label?: string;
  value: string;
}